// src/services/authService.ts
import axios from "./axiosConfig";

// API base URL
const API_URL = "http://localhost:5240/api/auth";

// Function to store user data in localStorage
const setUserSession = (accessToken: string, refreshToken: string, user: any) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
  localStorage.setItem("user", JSON.stringify(user));
};

// Function to get stored user data
const getUser = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};


const getCompanyId=() =>{
  
  const user = getUser();
  return user.company.id;
}
const getCompanyDescription=() =>{
  
  const user = getUser();
  return user.company.description;
}
// Function to get stored access token
const getAccessToken = () => localStorage.getItem("accessToken");

// Function to get refresh token
const getRefreshToken = () => localStorage.getItem("refreshToken");

// Function to remove user session (logout)
const logout = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
};

// Function to login user
const login = async (email: string, password: string) => {
  try {
    const response = await axios.post(`auth/login`, { email, password });
    const { accessToken, refreshToken, user } = response.data;

    // Store user session
    setUserSession(accessToken, refreshToken, user);
    return user;
  } catch (error: any) {
    throw error.response?.data?.message || "Login failed!";
  }
};


// Function to refresh token
const refreshToken = async () => {
  try {
    const token = getRefreshToken();
    if (!token) return logout();

    const response = await axios.post(`auth/refresh`, { token });
    const { accessToken } = response.data;

    if (accessToken) {
      localStorage.setItem("accessToken", accessToken);
    } else {
      logout();
    }
    return accessToken;
  } catch (error) {
    logout();
  }
};

export { login, logout, getUser, getAccessToken, refreshToken ,getCompanyDescription,getCompanyId  };
